import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { selectProduct, setVizLoading } from '../../../../store/visualizerSlice';
import ProductList from '../../ProductList/ProductList';
import StepNavigation from '../../StepNavigation/StepNavigation';
import styles from './BathHardware.module.css';

const SERIES_ID = '9723';
const SURFACE_NAME = 'Bathroom Hardware';

export default function BathHardware({ 
    stepIndex,
    room = '',
    onViewAllApplied, 
    onNext, 
    onPrevious 
}) {
    const dispatch = useDispatch();
    const stepSelections = useSelector(state => state.visualizer.stepSelections);
    const [selectedProduct, setSelectedProduct] = useState(null);

    const selectionKey = `BathHardware_${room}`;

    // Restore selection from Redux on mount
    useEffect(() => {
        const savedSelection = stepSelections[selectionKey];
        if (savedSelection?.product) {
            setSelectedProduct(savedSelection.product);
        }
    }, [stepSelections, selectionKey]);

    const handleProductSelect = (product) => {
        setSelectedProduct(product);
        
        console.log('BathHardware - Product selected:', product.color || product.name);
        
        dispatch(selectProduct({
            product,
            surfaceName: SURFACE_NAME,
            stepIndex,
            selectionKey
        }));
        
        const chamViz = document.getElementById('chamViz');
        if (!chamViz || !product.id) return;

        dispatch(setVizLoading(true));
        
        chamViz.applyByFilter(
            product.id,
            "",
            function(newSel) {
                if (this.name === SURFACE_NAME) {
                    return newSel;
                }
                return this.sel;
            },
            true
        );
    };

    return (
        <div className={styles.container}>
            <StepNavigation
                title="Hardware"
                onNext={onNext}
                onPrevious={onPrevious}
                onViewAllApplied={onViewAllApplied}
            />

            <div className={styles.productListContainer}>
                <ProductList
                    seriesId={SERIES_ID}
                    thumbSize="256"
                    onProductSelect={handleProductSelect}
                    titleAttribute="color"
                    descriptionAttribute="name"
                    gridClassName={styles.productGrid}
                    selectedId={selectedProduct?.id}
                />
            </div>
        </div>
    );
}

BathHardware.propTypes = {
    stepIndex: PropTypes.number.isRequired,
    room: PropTypes.string,
    onViewAllApplied: PropTypes.func,
    onNext: PropTypes.func,
    onPrevious: PropTypes.func
};
